import { sectionRenderer } from '@theme/section-renderer';

// A browser Back can restore the previous page's cart HTML from the back-forward
// cache even though Shopify retained later additions. Read the server cart and
// bypass Horizon's cached section HTML on that restore only.
window.addEventListener('pageshow', async (event) => {
  if (!event.persisted) return;

  try {
    const response = await fetch(`${Theme.routes.cart_url}.js`, { cache: 'no-store' });
    if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
    const cart = await response.json();
    if (!Number.isInteger(cart.item_count) || cart.item_count < 0) return;

    for (const icon of document.querySelectorAll('cart-icon')) {
      icon.renderCartBubble?.(cart.item_count, false);
    }

    const sections = [];
    if (document.getElementById('shopify-section-cart-drawer-section')) {
      sections.push(
        sectionRenderer.renderSection('cart-drawer-section', {
          cache: false,
          mode: 'hydration',
        }),
      );
    }
    const cartPage = document.querySelector('cart-items-component:not([data-drawer])');
    if (cartPage?.dataset.sectionId) {
      sections.push(
        sectionRenderer.renderSection(cartPage.dataset.sectionId, {
          cache: false,
          mode: 'full',
        }),
      );
    }
    await Promise.all(sections);
  } catch (error) {
    console.warn('[tcs-cart-history-sync] Could not refresh restored cart:', error);
  }
});
